import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import AdminConstants from 'constants/AdminConstants';

const ActionTypes = AdminConstants.ActionTypes;

export default {
  generateTrip({
    name,
    orderId,
    shipments,
    shipments_staging,
  }) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.GENERATE_TRIP_REQUEST,
      name,
      orderId,
      shipments,
      shipments_staging,
    });
  },

  saveAndApplyTrip(orderId, trip) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.SAVE_AND_APPLY_TRIP_REQUEST,
      orderId,
      trip,
    });
  },

  createTrip(trip) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CREATE_TRIP_REQUEST,
      trip,
    });
  },

  updateTrip(trip) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.UPDATE_TRIP_REQUEST,
      trip,
    });
  },

  getTrips(query = {}) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.GET_TRIPS_REQUEST,
      query,
    });
  },

};
